import { SessionRepository } from "../../../session/infra/repository/session.repository";
import { SessionListItem } from "../domain/session-list-item";

export class ListAllSessionsUseCase {
    static async execute(): Promise<SessionListItem[]> {
        const response = await SessionRepository.listAllSessions();
        if (response?.error) throw new Error("Erro ao listar sessões");
        return (response.data ?? []).map(
            (row) =>
                new SessionListItem(
                    row.id,
                    row.name,
                    row.workout,
                    row.workoutId,
                    row.drill,
                    row.createdAt,
                    this.mapStatus(row.status)
                ),
        );
    }

    private static mapStatus(status: string): string {
       return status === 'completed' ? 'Finalizado' : 'Em andamento';
    }
}
